export const getScopesGatewayUriFromAscensionGatewayUri = (ascensionUri: string): string =>
  `${ascensionUri.split('/legacy')[0]}/scopeofworks/graphql/`;
